import { useMemo } from 'react'
import { usePhases } from './usePhases'

// Derives the active phase from the full phase list:
// start_date <= today AND (end_date is null OR end_date >= today).
// Returns the most recently started match if multiple somehow overlap.
export function useCurrentPhase() {
  const { phases, loading } = usePhases()

  const current = useMemo(() => {
    const today = new Date().toLocaleDateString('en-CA')
    const matches = (phases || []).filter((p) => {
      if (!p?.start_date) return false
      if (p.start_date > today) return false
      if (!p.end_date) return true
      return p.end_date >= today
    })
    if (matches.length === 0) return null
    // Newest start_date wins.
    return matches.reduce((a, b) => (a.start_date > b.start_date ? a : b))
  }, [phases])

  return { currentPhase: current, loading }
}
